import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import Rating from "@mui/material/Rating";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 800,
  maxWidth: 1000,
  bgcolor: "background.paper",
  border: "1px solid lightgray",
  boxShadow: 24,
  p: 4,
  pt: 2,
  outline: "none",
};

export default function ReviewModal({ imgs, title, review, rating, name }) {
  const { t, i18n } = useTranslation();
  const [index, setIndex] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const prev = () => {
    if (index > 0) {
      setIndex(index - 1);
    } else {
      setIndex(imgs.length - 1);
    }
  };
  const next = () => {
    if (index === imgs.length - 1) {
      setIndex(0);
    } else {
      setIndex(index + 1);
    }
  };

  return (
    <div>
      {imgs &&
        imgs.map((img, idx) => {
          return (
            <img
              key={idx}
              onClick={handleOpen}
              src={img}
              width="50"
              height="50"
              alt=""
              style={{ cursor: "pointer", marginRight: "5px" }}
            />
          );
        })}
      {/* <Button onClick={handleOpen}>Open modal</Button> */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        style={{ minHeight: "400px" }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box
              onClick={handleClose}
              className="round"
              sx={{
                position: "relative",
                marginLeft: "auto",
                marginRight: 0,
                cursor: "pointer",
                p: 1,
                width: "10px",
              }}
            >
              <CloseIcon sx={{ fontSize: "32px" }} />
            </Box>

            <Box
              sx={{
                position: "relative",
                top: "-20px",
                display: "flex",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box onClick={prev}>
                    <ArrowBackIosIcon sx={{ cursor: "pointer" }} />
                  </Box>
                  {imgs &&
                    imgs.map((img, idx) => {
                      if (idx === index) {
                        return (
                          <img
                            key={idx}
                            onClick={handleOpen}
                            src={img}
                            alt=""
                            style={{
                              cursor: "pointer",
                              width: "500px",
                              height: "auto",
                              maxHeight: "500px",
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                          />
                        );
                      }
                    })}
                  <Box onClick={next}>
                    <ArrowForwardIosIcon sx={{ cursor: "pointer" }} />
                  </Box>
                </Box>
                <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                  <Box>
                    {imgs.map((img, idx) => {
                      return (
                        <img
                          key={idx}
                          onClick={(e) => setIndex(idx)}
                          src={img}
                          width="50"
                          height="50"
                          alt=""
                          style={{ cursor: "pointer", marginRight: "5px" }}
                        />
                      );
                    })}
                  </Box>
                </Typography>
              </Box>

              <Box sx={{ minWidth: "100px" }}>
                <Box sx={{ display: "flex", pb: 2 }}>
                  <img src="/img/user4.png" width="15" height="15" />{" "}
                  <Box sx={{ pl: 1, color: "gray" }}>
                    {name.substring(0, 4) + "****"}{" "}
                    <span style={{ color: "#21c387" }}>
                      ({t("Verified Buyer")})
                    </span>
                  </Box>
                </Box>
                <Rating
                  name="half-rating-read"
                  defaultValue={rating}
                  precision={0.5}
                  readOnly
                  sx={{ position: "relative", left: "-4px" }}
                />
                <Box
                  sx={{
                    fontSize: "16px",
                    py: 2,
                    lineHeight: "1.5em",
                    fontWeight: 600,
                  }}
                >
                  {title}
                </Box>
                <Box sx={{ color: "black" }}>{review}</Box>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
